export default "__VITE_ASSET__ZJne$n8t__"